__webpack_public_path__ = __CLIENT_HOLOCRON_MODULE_MAP__.modules['one-commercial-payments-enrollment-footer'].baseUrl;
import ModuleContainer from './components/OneCommercialPaymentsEnrollmentFooter';
export default ModuleContainer;
;
if (!global.BROWSER) {
  ModuleContainer.appConfig = Object.assign({}, ModuleContainer.appConfig, {
    appCompatibility: "^5.0.0"
  });
}